var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dates),function(date,i){return _c('div',{key:i},[_c('h2',[_vm._v(_vm._s(date.date))]),_c('div',{staticClass:"flex"},_vm._l((date.games),function(game,i){return _c('game-item',{key:i,attrs:{"game":game}})}),1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }